class Customer.Filter extends Backbone.Model
  urlRoot: '/customer/filters'

  defaults:
    is_transient: false
    user_id: null
    type: 'filter'
    editable: false
    name: 'Conversations'
    global: false
    users_group_ids: []
    operator_status_ids: []
    color: ''
    query:
      assigned_to_id: []
      users_group_id: []
      date_range:{from: null, to: null}
      assigned_to_me: false
      assigned_to_robot: false
      status: []
      tags: []
      intelligent_tags: {
        primary_tags: [], primary_tags_logic: 'OR', secondary_tags: [], secondary_tags_logic: 'OR',
        excluded_tags: [], excluded_tags_logic: 'OR'
      },
      intelligent_groups: {
        main_groups: [], main_groups_logic: 'OR', secondary_groups: [], secondary_groups_logic: 'OR',
        excluded_groups: [], excluded_groups_logic: 'OR'
      },
      groups: []
      sub_type: []
      sentiments: []
      search_text: ''
      order_by:
        order: 'desc'
        value: 'latest_content_date'
      followers: {min: null, max: null}
      appointments: null
      has_brand_response: null
      users: []
      custom_attributes: {tags: [], hierarchical_tags: []}
      primary_keywords: []
      secondary_keywords: []
      excluded_keywords: []
      primary_keywords_logic: 'OR'
      secondary_keywords_logic: 'OR'
      excluded_keywords_logic: 'OR'
    newContent: false
    checkForNewContent: true
    filter_collection_id: null
    latest_refresh: Date.create(1)
    filter_count_skips: 0

  initialize: ->
    super
    @newContent= false
    @set('user_id', Keepcon.current_user.id) if @isNew() # new filters are private as default
    @set('global', _.isNull(@get('user_id')))
    @callSummaryFirstTime = true

  isTransient: ->
    @get('is_transient')

  isPersisted: ->
    !@isTransient() && !@get('id') == 2 ** 30

  isNew: ->
    @get('id') in [undefined, null]

  isFilter: ->
    true

  @orderValues: ->
    latest_content_date: 'Date',
    status: 'Status',
    subtype: 'Type',
    ticket_priority: 'Priority'

  parse: (response, options) ->
    if response && response.query
      response.query = $.extend(true, @_copyOfDefaults().query, $.parseJSON(response.query))
    response

  toJSON: (options) ->
    @_queryWithDefaults() # Avoids firing change event
    super options

  _queryWithDefaults: ->
    @attributes.query = $.extend(true, @_copyOfDefaults().query, @get('query'))
    @

  _copyOfDefaults: ->
    $.extend(true, {}, @defaults)

  setCounter: (total, new_values) ->
    @_checkNewContentVariable(total, new_values)
    @_chargeFilterCountSkips()
    @previous_values = new_values
    @counter = total
    @set('counter', total)
    Backbone.trigger('update:counter', @)

  _chargeFilterCountSkips: ->
    skips = _.find(window.Customer.filterCountSkips, (step) => @counter > step.threshold)?.skips
    @set('filter_count_skips', skips) if skips

  isGlobal: ->
    @get('global') && _.isNull(@get('user_id'))

  select: () ->
    @markAsRead()
    Backbone.trigger('filter:selected', @)

  setCallSummaryFirstTime:(value) ->
    @callSummaryFirstTime = value

  getCallSummaryFirstTime:() ->
    @callSummaryFirstTime

  markAsRead: ->
    @checkForNewContent = false

  markAsUnread: ->
    @checkForNewContent = true

  getCounter: ->
   @counter

  hasUnseenContent: ->
    @newContent

  updateQuery: (query) ->
    @set('query', query)

  updateIntelligentTags: (intelligentTags) ->
    @get('query').intelligent_tags = intelligentTags

  updateTags: (tags) ->
    @get('query').tags = tags

  updateGroups: (groups) ->
    @get('query').groups = groups

  updateIntelligentGroups: (intelligent_groups) ->
    @get('query').intelligent_groups = intelligent_groups

  updateCustomAttributeTags: (customAttributeTags) ->
    @get('query').custom_attributes.tags = customAttributeTags

  updateCustomAttributeHierarchicalTags: (values) ->
    @get('query').custom_attributes.hierarchical_tags = values

  updateAssignedToId: (assignedToId) ->
    @get('query').assigned_to_id = assignedToId

  updateUsersGroupId: (usersGroupId) ->
    @get('query').users_group_id = usersGroupId

  updateIsAssignedToMe: (isAssignedToMe) ->
    @get('query').assigned_to_me = isAssignedToMe

  updateIsAssignedToRobot: (isAssignedToRobot) ->
    @get('query').assigned_to_robot = isAssignedToRobot

  updateHasResponse: (hasResponse) ->
    @get('query').has_brand_response = hasResponse

  updateVisibleBy: (usersGroupIds) ->
    @set('users_group_ids', usersGroupIds)

  updateVisibleByStatuses: (operatorStatusIds=[]) ->
    @set('operator_status_ids', operatorStatusIds)

  updateColor: (color) ->
    @set('color', color)

  updateFollowers: (min, max) ->
    @get('query').followers['min'] = min
    @get('query').followers['max'] = max

  updateAppointments:(appointments)->
    if !(appointments == "present" || appointments == "not-present")
      appointments = null
    @get('query').appointments = appointments

  updateUsers: (users) ->
    @get('query').users = users

  updateDateRange: (from, to) ->
    @get('query').date_range.from = from
    @get('query').date_range.to = to

  updateFolder: (folderId) ->
    @set('filter_collection_id', folderId)

  update: (callback) ->
    json = @toJSON()
    delete(json.query.search_text) # do not save this values in query
    delete(json.query.order_by) # do not save this values in query
    @save(json, success: (response) => callback(@))

  updateGlobal: (value) ->
    @set('global', value)

  _checkNewContentVariable: (total, new_values) ->
    if @previous_values != undefined
      has_changes = _.difference(new_values, @previous_values).length > 0 || (new_values && @previous_values.length != new_values.length)
    has_changes ||= total != @getCounter()
    @newContent = @newContent || has_changes

  getFilterCollectionId: ->
    parseInt(@get('filter_collection_id'))

  getOldFilterCollectionId: ->
    parseInt(@get('old_filter_collection_id'))

  firstLevel: ->
    _.isNull(@get('filter_collection_id'))

  secondLevel: ->
    !_.isNull(@get('filter_collection_id'))

  allFilters: ->
    @

  visibleFilters: ->
    @allFilters()

  needsQuickRefresh: ->
    (Date.create() - @get('latest_refresh')) > 10000

  skipsPeriodicRefresh: ->
    skips = @get('filter_count_skips')
    return false unless skips
    @set('filter_count_skips', skips - 1)
    true

  setNewContent: (value)->
    @newContent = value

  destroy: ->
    super
    @trigger 'destroy:filter', @
